import type {} from 'axios';

export const desktopApi = window.dsDesktop;

export const isTourInTour =
  (window.__DS_TOUR_IN_TOUR && window.__DS_RRWEB_CONSTRUCTED) ||
  (window.__DS_TOUR_IN_TOUR && !desktopApi);

export const isDesktop =
  !isTourInTour && (!!window.dsDesktop || !!window.__DS_TAB_ID);

export const isFromLive = !!window.isOverlayCapture;
